export default "__VITE_ASSET__DKADYQ8e__"